import { ImageCropperComponent } from './image-cropper.component';

export default angular
  .module('sfMobile.components.image-cropper', [
    'sfMobile.constants.files-upload-options',
    'sfMobile.services.image-cropper',
  ])
  .component('sfImageCropper', ImageCropperComponent).name;
